// extracted by mini-css-extract-plugin
module.exports = {"container":"Responses_container__318fq","title":"Responses_title__3_oDc"};